<template>
  <div class="login-div">
    <b-tabs align="center">
      <b-tab title="Login">
        <b-container>
          <div id="Login">
            <div style="height: 2rem"></div>
            <h2>Log In</h2>
            <div>
              <b-form id="login-form" @submit.prevent="login">
                <b-form-input
                  v-model="username"
                  style="
                    background: #f1eef1;
                    border: #422c58 2px solid;
                    margin: 1rem 0;
                  "
                  required
                  placeholder="Enter your username"
                />
                <b-form-input
                  v-model="password"
                  style="
                    background: #f1eef1;
                    border: #422c58 2px solid;
                    margin: 1rem 0;
                  "
                  type="password"
                  required
                  placeholder="Enter your password"
                />
                <b-link style="float: left" href="/ForgotPassword">
                  Forgot Password?
                </b-link>
                <b-button
                  v-if="!loadingLogin"
                  id="submit-btn"
                  size="lg"
                  type="submit"
                  style="
                    background: #422c58;
                    float: right;
                    padding-left: 2.5rem;
                    padding-right: 2.5rem;
                  "
                >
                  Login
                </b-button>
                <b-button
                  v-if="loadingLogin"
                  size="lg"
                  style="background: #422c58; float: right; margin-right: 1rem"
                  disabled
                >
                  <b-spinner
                    small
                    type="grow"
                    style="color: #dfdfdf"
                  ></b-spinner>
                  Loading...
                </b-button>
              </b-form>
            </div>
          </div>
        </b-container>
      </b-tab>
      <b-tab title="Register">
        <b-container>
          <div id="register">
            <div style="height: 2rem"></div>
            <h2>Create An Account</h2>
            <b-form id="register-form" @submit.prevent="register">
              <b-form-input
                v-model="c_username"
                placeholder="Create your username"
                style="
                  background: #f1eef1;
                  border: #422c58 2px solid;
                  margin: 1rem 0;
                "
              ></b-form-input>
              <b-form-input
                v-model="c_password"
                type="password"
                style="
                  background: #f1eef1;
                  border: #422c58 2px solid;
                  margin: 1rem 0;
                "
                placeholder="Create your password"
              />
              <b-form-input
                v-model="c_email"
                style="
                  background: #f1eef1;
                  border: #422c58 2px solid;
                  margin: 1rem 0;
                "
                placeholder="Provide your email"
              />
              <b-button
                v-if="!loadingCreate"
                id="submit-btn"
                type="submit"
                size="lg"
                style="background: #422c58; float: right"
                >Create New</b-button
              >
              <b-button
                v-if="loadingCreate"
                size="lg"
                style="background: #422c58; float: right"
                disabled
              >
                <b-spinner small type="grow" style="color: #dfdfdf"></b-spinner>
                Loading...
              </b-button>
            </b-form>
          </div>
        </b-container>
      </b-tab>
      <b-tab title="About">
        <div class="about" style="text-align: left">
          <h1 style="text-align: center">Hello!</h1>
          <p>
            This Website is intended for players of the TTRPG
            Crescent<b-icon-moon></b-icon-moon>
          </p>
          <p>
            This Application is in early alpha and we expect many of the
            features to change in both function and look, so please be pateint
            with any features that aren't yet solid. Any custom gear you make
            within the tools provided is not yet hooked to an endpoint so if it
            dissapears, that's why. Otherwise, most parts of the app will save
            to our database with a few small exceptions. Happy Adventuring!
          </p>
          <h2 style="text-align: center">
            Features we intend to add/expand upon
          </h2>
          <p>
            - custom attack builder for weapon skills that guides you through
            building an attack and save it for later reference
          </p>
          <p>- search filtering on abilities list</p>
          <p>
            - [[IN PROGRESS]]custom gear with propagating passive effects,
            potentially with a generated code so this gear can be easily shared
            with others
          </p>
          <p>
            - [[IN PROGRESS]]An entire side of the app to support GMs with a
            Monster Maker, Journal, NPC builder, character references and more
          </p>
          <p>- Much, much, more...</p>
          <p></p>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import store from "@/store/store";
import {
  submitLogin,
  submitRegister,
  getEmail,
  setToken,
} from "@/common/authentication/auth";
import { getAllCharacters } from "@/common/authentication/character";
import { getAllAdventures, getAllInvites } from "@/common/adventure/adventure";

export default {
  name: "UserLogin",
  store,
  data: () => ({
    username: "",
    characterName: "",
    password: "",

    //c_username, c_characterName, c_password are for creating new one
    c_username: "",
    c_characterName: "",
    c_password: "",
    c_email: "",

    alert1: false,
    alert2: false,
    loadingLogin: false,
    loadingCreate: false,
  }),
  methods: {
    /* This "CharacterCreate()" is linked to "Create New" button in line 22 of this Login.vue, when the button is
     pushed, then this function in called. Or you can rename this function and change @click ="" in line 22
    */
    async register() {
      this.loadingCreate = true;
      const response = await submitRegister(
        this.c_username,
        this.c_password,
        this.c_email
      );
      if (response.status === 200) {
        alert("Account has been created. Login below");
        this.$store.commit("setUsername", this.c_username);
        this.$store.commit("setPassword", this.c_password);
      } else if (response.status === 422) {
        alert("Username is taken");
      } else {
        alert("Something went wrong. Try again later");
      }
      this.loadingCreate = false;
    },
    async login(event) {
      this.loadingLogin = true;
      event.preventDefault();
      const response = await submitLogin(this.username, this.password);
      // If we had a successful call set the token and redirect
      if (response.status === 200) {
        setToken(response.data.token);
        this.$store.commit("setUsername", this.username);
        this.$store.commit("setPassword", this.password);
        this.$store.commit("setUserId", response.data.userId);
        await this.getCharacters();
        //await this.getAdventures();
        //await this.getInvites();
        //await this.getEmail();
        await this.$router.replace({ path: "/" });
      } else {
        // TODO: Give user failure message
      }
      this.loadingLogin = false;
    },
    async getCharacters() {
      await getAllCharacters().then((response) => {
        console.log("response");
        this.$store.commit("setCharacters", response.data);
      });
    },
    async getEmail() {
      await getEmail(this.username).then((response) => {
        this.$store.commit("setEmail", response.data.email);
      });
    },
    async getAdventures() {
      await getAllAdventures().then((response) => {
        this.$store.commit("setAdventures", response.data.adventures);
      });
    },

    async getInvites() {
      await getAllInvites().then((response) => {
        this.$store.commit("setInvites", response.data.invites);
      });
    },
    route() {
      // temp
      this.$router.replace({ name: "App" });
    },
  },
};
</script>

<style>
.submit-btn {
  background: #422c58;
  float: right;
  margin-right: 1rem;
}
.login-div {
  background: #dfdfdf;
  height: calc(100% - 84px);
  min-height: 100vh;
}
/*.form-control {*/
/*  background: #f1eef1;*/
/*  border: #422c58 2px solid;*/
/*  margin: 1rem 0;*/
/*}*/
/*.nav {*/
/*  justify-content: center;*/
/*  margin-bottom: 2rem !important;*/
/*}*/
.nav-tabs .nav-link {
  margin-bottom: 0 !important;
  border: none !important;
  border-radius: 0 !important;
}
</style>
